import UrlResolver from 'ha/helpers/UrlResolver';

import { ISODate } from 'ha/helpers/hadate/types';

export interface Translations {
  [key: string]: string;
}

export interface IntlConfig {
  lang: Language;
  baseDomain: string;
  messages: Translations;
}

// tslint:disable-next-line no-any
export type TranslateFunc = (key: string, ...args: any[]) => string;

export type FormatDateFunc = (format: string, isoDate: ISODate) => string;

export type ToLocalizedStringFunc = (isoDate: string) => string;

export interface IntlObject {
  lang: Language;
  locale: Locale;
  messages: Translations;
  urlResolver: UrlResolver;
  T: TranslateFunc;
  formatDate: FormatDateFunc;
  fromNow: FormatDateFunc;
  toLocalizedString: ToLocalizedStringFunc;
}

export interface IntlProps {
  intl: IntlObject;
}

export enum Language {
  en = 'en',
  fr = 'fr',
  de = 'de',
  es = 'es',
  it = 'it',
  nl = 'nl',
  pt = 'pt',
  zh = 'zh',
}

export enum Locale {
  en = 'en-gb',
  fr = 'fr',
  de = 'de',
  es = 'es',
  it = 'it',
  nl = 'nl',
  pt = 'pt',
  zh = 'zh-cn',
}
